export const UserTiers = {
  ADMIN: 'admin', //VIP_PORTAL_ADMIN
  IndustryOnly: 'industry-only', // VIP_PARTNER
  FDA: 'fda', // FDA_ADMIN, FDA_REVIEWER
  Org: 'org', // ORG_SPONSOR,ORG_COORDINATOR
  OrgUnit: 'org-unit', // ORG_UNIT_SPONSOR,ORG_UNIT_COORDINATOR
  NoTier: 'no-tier' // ISACA_MDDAP_APPRAISER
};
